import { render, staticRenderFns } from "./PackageProject.vue?vue&type=template&id=14ed7053&scoped=true&"
import script from "./PackageProject.vue?vue&type=script&lang=js&"
export * from "./PackageProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ed7053",
  null
  
)

export default component.exports